export default __webpack_public_path__ + "static/media/Wall_Conveyor_x3_Grey.256.6495d1f7.png";